import { withWebViewLayout } from "@/layout/withWebViewLayout";
import { GameTemplateWebView } from "@/components/templates/GameTemplateWebView";
import React from "react";

import { HomeWebView } from "@/components/webview/games/main/HomeWebView";
import { MetaQuestWebView } from "@/components/webview/games/main/MetaQuestWebView";
import { SteamVrWebView } from "@/components/webview/games/main/SteamVrWebView";
import { PicoWebView } from "@/components/webview/games/main/PicoWebView";
import { PsVr2WebView } from "@/components/webview/games/main/PsVr2WebView";
import { PcGameWebView } from "@/components/webview/games/main/PcGameWebView";
import { SimRacingWebView } from "@/components/webview/games/main/SimRacingWebView";
import { AudioToHapticsWebView } from "@/components/webview/games/main/AudioToHapticsWebView";
import { useWebViewBridgeWorker } from "@/components/webview/hooks/useWebViewBridgeWorker";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import GamesTabMenuWebView, {
  GameTabsWebview,
} from "@/components/templates/GameTabMenuWebView";

const tabItems = [
  { label: GameTabsWebview.Home },
  { label: GameTabsWebview.MetaQuest },
  { label: GameTabsWebview.SteamVR },
  { label: GameTabsWebview.Pico },
  { label: GameTabsWebview.PSVR2 },
  { label: GameTabsWebview.PCGame },
  { label: GameTabsWebview.SimRacing },
  { label: GameTabsWebview.AudioToHaptic },
];

const WebviewGamesPage = () => {
  // 앱 -> 웹 수신 응답 훅스
  useWebViewBridgeWorker();

  return (
    <section>
      <GameTemplateWebView>
        <section className="flex flex-col bg-black text-white">
          <GamesTabMenuWebView
            tabItems={tabItems}
            activeList={[
              <HomeWebView key="home" />,
              <MetaQuestWebView key="meta-quest" />,
              <SteamVrWebView key="steamVr" />,
              <PicoWebView key="pico" />,
              <PsVr2WebView key="psvr2" />,
              <PcGameWebView key="pc-game" />,
              <SimRacingWebView key="sim-racing" />,
              <AudioToHapticsWebView key="audio-to-haptics" />,
            ]}
          />
        </section>
      </GameTemplateWebView>
    </section>
  );
};

export default withWebViewLayout(WebviewGamesPage);

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      // `gnb` — 키 선택 다이얼로그·게임 카드 할인 배너 같은 공용 컴포넌트가 읽는다. 앱은 웹뷰를
      // `/ja/`·`/ko/` 등으로도 연다 — 빠지면 그 문구만 키(영문) 그대로 나온다. 렌더 트리가 읽는
      // ns 는 `__tests__/i18n/webview-ns-loaded.test.ts` 가 파생해 검사한다(docs/i18n.md §앱 웹뷰).
      ...(await serverSideTranslations(locale ?? "en", ["games", "gnb"])),
    },
  };
};
